import PagseguroGateway from './PagseguroGateway';
import StripeGateway from './StripeGateway';
import PaypalGateway from './PaypalGateway';
import ShopifyGateway from './ShopifyGateway';
import TwocheckoutGateway from './TwocheckoutGateway';
import SandboxGateway from './SandboxGateway';


export default {
    PagseguroGateway,
    StripeGateway,
    PaypalGateway,
    ShopifyGateway,
    TwocheckoutGateway,
    SandboxGateway,
}
